"use client";

import { c as _c } from "react/compiler-runtime";
import { refreshTprWorkflowProgress } from "@/configuration/groups/tpr/components/workflow-progress";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { toast } from "@/src/hooks/use-toast";
import { useApproveTaskMutation, useLocalTaskUpdateMutation } from "@/src/lib/data-fetchers/tasks-fetchers";
import { type Task, TaskStatus } from "@/src/models/task";
export function TprOpsContinueButton(t0) {
  const $ = _c(13);
  const {
    task,
    successTitle,
    successDescription,
    errorTitle: t1
  } = t0;
  const errorTitle = t1 === undefined ? "Unable to continue the workflow" : t1;
  const approvalMutation = useApproveTaskMutation();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      invalidateOnSettled: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const localTaskUpdateMutation = useLocalTaskUpdateMutation(t2);
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");
  let t3;
  if ($[1] !== approvalMutation || $[2] !== errorTitle || $[3] !== invalidateInstructions || $[4] !== localTaskUpdateMutation || $[5] !== successDescription || $[6] !== successTitle || $[7] !== task) {
    t3 = async () => {
      ;
      try {
        await approvalMutation.mutateAsync({
          taskId: task.id,
          approved: true
        });
        localTaskUpdateMutation.mutate({
          ...task,
          status: TaskStatus.PROCESSING
        });
        refreshTprWorkflowProgress(invalidateInstructions);
        toast({
          title: successTitle,
          description: successDescription
        });
      } catch (t4) {
        const error = t4;
        toast({
          title: errorTitle,
          description: error instanceof Error ? error.message : "Refresh the task and try again.",
          variant: "destructive"
        });
      }
    };
    $[1] = approvalMutation;
    $[2] = errorTitle;
    $[3] = invalidateInstructions;
    $[4] = localTaskUpdateMutation;
    $[5] = successDescription;
    $[6] = successTitle;
    $[7] = task;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleContinue = t3;
  const t4 = approvalMutation.isPending || localTaskUpdateMutation.isPending;
  const t5 = approvalMutation.isPending ? "Continuing..." : "Continue";
  let t6;
  if ($[9] !== handleContinue || $[10] !== t4 || $[11] !== t5) {
    t6 = <Button size="sm" onClick={handleContinue} disabled={t4}>{t5}</Button>;
    $[9] = handleContinue;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}